export default __webpack_public_path__ + "static/media/tube-3-h-en.b340df02.svg";